import { Mention } from "@tiptap/extension-mention";

const CustomMention = Mention.extend({
  addStorage() {
    return {
      markdown: {
        /**
         * Serialize a mention node to ((id)) in markdown output.
         * This replaces the HTML-regex hack in transformMentions().
         */
        serialize(state: any, node: any) {
          state.write(`((${node.attrs.id}))`);
        },
        parse: {
          /**
           * Add a markdown-it inline rule so that ((id)) in a markdown
           * string is parsed as a mention node (not plain text).
           * This replaces the injectMentionsIntoDoc() hack on load.
           */
          setup(md: any) {
            md.inline.ruler.push("mention", (state: any, silent: boolean) => {
              if (
                state.src.charCodeAt(state.pos) !== 40 ||
                state.src.charCodeAt(state.pos + 1) !== 40
              ) {
                return false;
              }
              const end = state.src.indexOf("))", state.pos + 2);
              if (end === -1) return false;
              if (!silent) {
                const id = state.src.slice(state.pos + 2, end);
                const token = state.push("html_inline", "", 0);
                token.content = `<span data-type="mention" data-id="${id}" data-mention-suggestion-char="/">${id}</span>`;
              }
              state.pos = end + 2;
              return true;
            });
          },
        },
      },
    };
  },

  addAttributes() {
    return {
      ...this.parent?.(),
      label: {
        default: null,
        parseHTML: (element) => element.getAttribute("data-label") || null,
        renderHTML: (attributes) => {
          if (!attributes.label) return {};
          return { "data-label": attributes.label };
        },
      },
      nodeColor: {
        default: null,
        parseHTML: (element) => element.getAttribute("data-node-color") || null,
        renderHTML: (attributes) =>
          attributes.nodeColor
            ? { "data-node-color": attributes.nodeColor }
            : {},
      },
      nodeImage: {
        default: null,
        parseHTML: (element) => element.getAttribute("data-node-image") || null,
        renderHTML: (attributes) =>
          attributes.nodeImage
            ? { "data-node-image": attributes.nodeImage }
            : {},
      },
      nodeName: {
        default: null,
        parseHTML: (element) => element.getAttribute("data-node-name") || null,
        renderHTML: (attributes) =>
          attributes.nodeName ? { "data-node-name": attributes.nodeName } : {},
      },
      nodeKind: {
        default: null,
        parseHTML: (element) => element.getAttribute("data-node-kind") || null,
        renderHTML: (attributes) =>
          attributes.nodeKind ? { "data-node-kind": attributes.nodeKind } : {},
      },
      class: {
        default: null,
        renderHTML: (attributes) => ({
          class: attributes.class,
        }),
      },
      mentionSuggestionChar: {
        default: "/",
        parseHTML: (element) =>
          element.getAttribute("data-mention-suggestion-char"),
        renderHTML: (attributes) => {
          if (!attributes.mentionSuggestionChar) return {};
          return {
            "data-mention-suggestion-char": attributes.mentionSuggestionChar,
          };
        },
      },
      prefix: {
        default: "",
        parseHTML: (element) => element.getAttribute("data-prefix") || "",
        renderHTML: (attributes) => ({
          "data-prefix": attributes.prefix || "",
        }),
      },
      icon: {
        default: "",
        parseHTML: (element) => element.getAttribute("data-icon") || "",
        renderHTML: (attributes) => ({
          "data-icon": attributes.icon || "",
        }),
      },
      color: {
        default: "default",
        parseHTML: (element) => element.getAttribute("data-color") || "default",
        renderHTML: (attributes) => ({
          "data-color": attributes.color || "default",
        }),
      },
    };
  },
});

export default CustomMention;
